<template>
  <div v-if="!filtered" class="table-filter" @click="$emit('toggleFilter')">
    <span>Filter</span
    ><apio-icon size="24" name="ui-filter" lightModeColour="cyan" darkModeColour="cyan" />
  </div>
  <div v-else class="table-filter table-filter__active" @click="$emit('toggleFilter')">
    <span>Edit filter</span
    ><apio-icon size="16" class="table-filter__purple-icon" name="ui-filter" lightModeColour="white" darkModeColour="white" />
  </div>
</template>

<script>
export default {
  name: "TableFilter",
  props: {
    filtered: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss"  scoped>
.table-filter {
  cursor: pointer;
  align-items: center;
  background: white;
  border-radius: 16px;
  border: 1px solid var(--apio-cyan);
  color: var(--apio-cyan);
  display: flex;
  font-size: var(--font-tiny-size) !important;
  font-weight: var(--font-extra-bold);
  height: 32px;
  justify-content: space-between;
  line-height: 1.33;
  padding: 8px 12px;
  text-transform: uppercase;
  min-width: 106px;

  &__active {
    border: 1px solid var(--apio-purple);
    color: var(--apio-purple);
  }

  &__purple-icon {
    background-color: var(--apio-purple);
    border-radius: 50px;
  }

  @media (max-width: 1024px) {
    width: 100%;
    font-size: var(--font-small-size);
    text-transform: uppercase;
  }
}
</style>



